class AluminiumBifoldDoor {
  constructor() {
    this.buyingJourney = document.querySelector("buying-journey");
    this.skipAstragalStep = false;
    this.aluminiumBifold = this;
    this.target = this.buyingJourney;
    this.buyingJourneyApi = this.buyingJourney.buyingJourneyApi;
    this.finishStepAt = 15;

    //Object holding the information for whole Buying Journey.
    this.buyingJourneyObject = {
      productType: "aluminium_doors",
      id: null,
      title: null,
      panelInfo: { panelWidth: null, panelHeight: null, orientation: null },
      panelSize: {
        value: null,
        variantId: null,
        totalPrice: 0,
        quantity: 1,
        panelImage: null,
        stackingDirection: null,
      },
      panelOutsideColour: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      panelInsideColour: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      panelHandle: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelGlass: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      blinds: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      barsfitting: {
        value: null,
        typeVariantId: null,
        orientationVariantId: null,
        quantityVariantId: null,
        quantity: 0,
        totalPrice: 0,
        direction: null,
      },
      trickleVents: {
        value: null,
        variantId: null,
        quantity: 1,
        totalPrice: 0,
      },
      profileAddons: {
        left: null,
        leftPrice: 0,
        right: null,
        rightPrice: 0,
        top: null,
        topPrice: 0,
        value: null,
      },
      postCode: { value: null },
      cill: { value: null, totalPrice: 0, variantId: null, quantity: 1 },
      threshold: { value: null, totalPrice: 0, variantId: null },
      accessIssue: { value: null, orderNote: null },
      gtAccessQoute: {
        firstName: null,
        lastName: null,
        mobile: null,
        email: null,
      },
      totalPrice: 0,
      invoiceUrl: null,
    };

    // step functions that will perform calculation based on selection in previous steps
    this.stepActions = {
      0: () =>
        this.getWindowSize(
          this.buyingJourneyObject,
          this.buyingJourney.querySelectorAll(".step-size input")
        ),
      1: this.calculatePanelSize.bind(this),
      2: this.getPanelSize.bind(this),
      3: this.getOrientation.bind(this),
      4: this.getOutsideColor.bind(this),
      5: this.getInsideColor.bind(this),
      6: this.getPanelHandle.bind(this),
      7: this.getGlassType.bind(this),
      8: this.getBlind.bind(this),
      9: this.getBarsFittingType.bind(this),
      10: this.getBarsFittingOrientation.bind(this),
      11: this.getBarsFittingQuantity.bind(this),
      12: this.getTrickleVents.bind(this),
      13: this.handleThreshold.bind(this),
      14: this.getThreshold.bind(this),
      15: this.getCill.bind(this),
      16: this.getpostcode.bind(this),
      17: this.getGatewayAccessQuote.bind(this),
      18: this.buyingJourney.handleAddMoreProducts.bind(this.buyingJourney),
      19: this.buyingJourney.readyQuoteOverview.bind(this.buyingJourney),
    };
  }

  connectedCallback() {
    this.render();
  }

  render() { }

  //First step assign event listener to input fields
  getWindowSize() {
    console.log("Width and height");

    let inputs = this.target.querySelectorAll(".step-size input");

    inputs.forEach((input) => {
      if (input.name == "panel-width") {
        input.value = this.buyingJourneyObject.panelInfo.panelWidth;
      }
      if (input.name == "panel-height") {
        input.value = this.buyingJourneyObject.panelInfo.panelHeight;
      }

      const updateButton = () => {
        this.validateInput(this.buyingJourneyObject, input)
          ? this.target.setActiveNextButton()
          : this.target.setDisableNextButton();
      };

      updateButton();
      input.addEventListener("input", updateButton);

      input.dispatchEvent(this.buyingJourney.changeEvent);
    });
  }

  //Based on added width and height calcualte the Panel Size for Step 2
  calculatePanelSize() {
    console.log("No. of panels ");

    const selectedPanelValue = this.buyingJourneyObject.panelSize.value;
    const selectedPanelDirection =
      this.buyingJourneyObject.panelSize.stackingDirection;

    const panels = this.target.querySelectorAll(
      ".offered-product-wrapper .panel-wrapper"
    );

    panels.forEach((panel) => {
      if (panel) {
        const panelSizeInput = panel.querySelector('input[name="panel_size"]');
        panel.classList.add("hidden");

        if (panelSizeInput) {
          const panelSizeValue =
            parseInt(panelSizeInput.dataset.panelSize) || 0;
          const panelOption1 = panelSizeInput.dataset.option1;
          const panelMinWidth = panelSizeValue * 600;
          const panelMaxWidth = panelSizeValue * 1200;

          const similarPanel = Array.from(panels).filter((panel) =>
            panel.querySelector('input[data-option1="' + panelOption1 + '"]')
          );

          if (similarPanel) {
            for (var i = 0; i < similarPanel.length; i++) {
              const similarPanelInput = similarPanel[i].querySelector("input");
              if (
                similarPanelInput.dataset.panelHeight >=
                this.buyingJourneyObject.panelInfo.panelHeight &&
                this.buyingJourneyObject.panelInfo.panelWidth >=
                panelMinWidth &&
                this.buyingJourneyObject.panelInfo.panelWidth <= panelMaxWidth
              ) {
                similarPanel[i].classList.remove("hidden");

                const valueMatch =
                  selectedPanelValue == null ||
                  similarPanelInput.value.includes(selectedPanelValue);
                const directionMatch =
                  selectedPanelDirection == null ||
                  similarPanelInput.value.includes(selectedPanelDirection);

                if (valueMatch && directionMatch) {
                  similarPanelInput.checked = true;
                }

                break;
              }
            }
          }
        }
      }
    });

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_size"]');
  }

  //Step 3: show orientation and get panel size based on height and width
  getPanelSize() {
    console.log("Orientation");

    if (this.buyingJourneyObject.panelInfo.orientation != null) {
      const selectedOrientation = this.target.querySelector(
        'input[value="' + this.buyingJourneyObject.panelInfo.orientation + '"]'
      );
      if (selectedOrientation) {
        selectedOrientation.checked = true;
        selectedOrientation.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    const selectedPanel = this.target.querySelector(
      'input[name="panel_size"]:checked'
    );
    if (selectedPanel) {
      this.buyingJourneyObject.panelSize.value =
        selectedPanel.dataset.panelSize || null;
      this.buyingJourneyObject.panelSize.variantId =
        selectedPanel.dataset.variantId || null;
      this.buyingJourneyObject.panelSize.totalPrice = this.convertPrice(
        selectedPanel.dataset.price
      );
      this.buyingJourneyObject.panelSize.panelImage =
        selectedPanel.nextElementSibling.querySelector("img").src;
      if (selectedPanel.dataset.option1.includes("Left")) {
        this.buyingJourneyObject.panelSize.stackingDirection = "Left";
      } else if (selectedPanel.dataset.option1.includes("Right")) {
        this.buyingJourneyObject.panelSize.stackingDirection = "Right";
      } else {
        const sizeLeft = selectedPanel.dataset.option1.split("_")[0];
        const sizeRight = selectedPanel.dataset.option1.split("_")[2];
        this.buyingJourneyObject.panelSize.stackingDirection =
          sizeLeft + " Left " + (sizeRight ? sizeRight + ", Right" : "");
      }
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="orientation"]');
  }

  //Step 4: show outside colour and get selected orientation
  getOrientation() {
    console.log("Outside Colour");

    if (this.buyingJourneyObject.panelOutsideColour.variantId != null) {
      const selectedColorOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelOutsideColour.variantId +
        '"]'
      );
      if (selectedColorOption) {
        selectedColorOption.checked = true;
        selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    const selectedOrientation = this.target.querySelector(
      'input[name="orientation"]:checked'
    );
    if (selectedOrientation) {
      this.buyingJourneyObject.panelInfo.orientation =
        selectedOrientation.value || "";
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_outside_color"]');
  }

  //Step 5: show inside colour and get selected outside colour
  getOutsideColor() {
    console.log("Inside Colour");

    if (this.buyingJourneyObject.panelInsideColour.variantId != null) {
      const selectedColorOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelInsideColour.variantId +
        '"]'
      );
      if (selectedColorOption) {
        selectedColorOption.checked = true;
        selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    const selectedOutsideColor = this.target.querySelector(
      'input[name="panel_outside_color"]:checked'
    );

    if (selectedOutsideColor) {
      this.buyingJourneyObject.panelOutsideColour.value =
        selectedOutsideColor.dataset.ralvalue || null;
      this.buyingJourneyObject.panelOutsideColour.variantId =
        selectedOutsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelOutsideColour.totalPrice =
        this.convertPrice(selectedOutsideColor.dataset.price);
      this.buyingJourneyObject.panelOutsideColour.quantity =
        parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    this.target
      .querySelectorAll('input[name="panel_inside_color"]')
      .forEach((insideColour) => {
        if (
          !(
            insideColour.dataset.ralvalue ==
            this.buyingJourneyObject.panelOutsideColour.value ||
            insideColour.value.includes("RAL") ||
            insideColour.value.includes("White")
          )
        ) {
          insideColour.closest(".panel-wrapper").classList.add("hidden");
        } else {
          //insideColour.checked = true;
          insideColour.closest(".panel-wrapper").classList.remove("hidden");
        }
      });

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_inside_color"]');
  }

  //Step 6: Show Handles and get the selected inside colours
  getInsideColor() {
    console.log("Handles");

    const selectedInsideColor = this.target.querySelector(
      'input[name="panel_inside_color"]:checked'
    );

    if (selectedInsideColor) {
      this.buyingJourneyObject.panelInsideColour.value =
        selectedInsideColor.dataset.ralvalue || null;
      this.buyingJourneyObject.panelInsideColour.variantId =
        selectedInsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelInsideColour.totalPrice = this.convertPrice(
        selectedInsideColor.dataset.price
      );
      this.buyingJourneyObject.panelInsideColour.quantity =
        parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    if (this.buyingJourneyObject.panelHandle.variantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelHandle.variantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    this.setupOptionListeners('input[name="handles"]');
  }

  //Step 7: show glass sizes and get the selected handles
  getPanelHandle() {
    const glassSize =
      (this.buyingJourneyObject.panelInfo.panelWidth / 1000) *
      (this.buyingJourneyObject.panelInfo.panelHeight / 1000);
    const glassSizeOptions = this.target.querySelectorAll(
      'input[name="glass_size"]'
    );
    const classInstance = this;
    glassSizeOptions.forEach((radio) => {
      radio.addEventListener("change", function () {
        checkForSelectedGlass(this);
      });

      if (radio && radio.dataset.variantPrice > 0) {
        const totalGlassPrice = Math.round(
          parseFloat(radio.dataset.variantPrice).toFixed(2) * glassSize
        );
        radio.dataset.price = totalGlassPrice;
        const panelPriceElement = radio
          .closest(".panel-wrapper")
          .querySelector(".panel-price");
        if (panelPriceElement) {
          panelPriceElement.innerHTML =
            totalGlassPrice === 0
              ? '<span class="free-badge">Free included </span>'
              : "+£" + totalGlassPrice;
        }
      }
    });

    const selectedGlass = this.target.querySelector(
      'input[name="glass_size"]:checked'
    );

    if (selectedGlass) {
      checkForSelectedGlass(selectedGlass);
    }

    const selectedHandle = this.target.querySelector(
      'input[name="handles"]:checked'
    );

    if (selectedHandle) {
      this.buyingJourneyObject.panelHandle.value = selectedHandle.value || null;
      this.buyingJourneyObject.panelHandle.variantId =
        selectedHandle.dataset.variantId || null;
      this.buyingJourneyObject.panelHandle.totalPrice = this.convertPrice(
        selectedHandle.dataset.price
      );
    }

    if (this.buyingJourneyObject.panelGlass.variantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelGlass.variantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    this.buyingJourney.prevStepButton.dataset.decrement = 0;

    function checkForSelectedGlass(radio) {
      if (
        ["55029469544783", "55029469577551", "55029469708623"].includes(
          radio.dataset.variantId
        )
      ) {
        classInstance.buyingJourney.nextStepButton.dataset.increment = 0;
      } else {
        console.log("Skip blind step");
        classInstance.buyingJourney.nextStepButton.dataset.increment = 1;
      }
    }

    this.setupOptionListeners('input[name="glass_size"]');
    console.log(this.buyingJourneyObject);
  }

  updateGlassValues() {
    //get the selected value for the glass on this step
    const selectedGlassType = this.target.querySelector(
      'input[name="glass_size"]:checked'
    );

    if (selectedGlassType) {
      this.buyingJourneyObject.panelGlass.value = selectedGlassType.value;
      this.buyingJourneyObject.panelGlass.variantId =
        selectedGlassType.dataset.variantId;
      this.buyingJourneyObject.panelGlass.totalPrice = Math.round(
        this.convertPrice(selectedGlassType.dataset.price)
      );
    }
  }

  //Step 8: Show the Bars fitting type and get the selected glass type.
  getGlassType() {
    console.log("Blinds");

    // Recalculate glass data-price from variantPrice × glassSize.
    // Normally done in getPanelHandle (step 6), but that step does not run
    // when the user edits a quote and jumps directly to this step.
    const glassSize =
      (this.buyingJourneyObject.panelInfo.panelWidth / 1000) *
      (this.buyingJourneyObject.panelInfo.panelHeight / 1000);
    this.target.querySelectorAll('input[name="glass_size"]').forEach((radio) => {
      if (radio && radio.dataset.variantPrice > 0) {
        const totalGlassPrice = Math.round(
          parseFloat(radio.dataset.variantPrice).toFixed(2) * glassSize
        );
        radio.dataset.price = totalGlassPrice;
        const panelPriceElement = radio
          .closest(".panel-wrapper")
          .querySelector(".panel-price");
        if (panelPriceElement) {
          panelPriceElement.innerHTML =
            totalGlassPrice === 0
              ? '<span class="free-badge">Free included </span>'
              : "+£" + totalGlassPrice;
        }
      }
    });

    this.updateGlassValues(); // make sure we have the latest glass values

    const windowBlinds = this.target.querySelectorAll('input[name="blinds"]');

    windowBlinds.forEach((blind) => {
      const blindsPrice =
        this.convertPrice(blind.dataset.price) *
        parseInt(this.buyingJourneyObject.panelSize.value);

      if (+blind.dataset?.price > 0) {
        blind
          .closest(".panel-wrapper")
          .querySelector(".panel-price").innerHTML = "£" + blindsPrice;
        blind
          .closest(".panel-wrapper")
          .querySelector(".panel-price").dataset.finalPrice = blindsPrice;
      }

      // Add change event listener to each blind option
      blind.addEventListener("change", () => {
        // If they select "yes" to blinds, set increment to 3 to skip steps 9, 10, and 11
        if (blind.value.toLowerCase() === "yes") {
          this.buyingJourney.nextStepButton.dataset.increment = 3;
          console.log("Skip steps 9, 10, and 11 because blinds = yes");
          this.getBlind();
          this.skipAstragalStep = true;
        }
        // If they select "no" to blinds, set increment to 0 to not skip any steps
        else if (blind.value.toLowerCase() === "no") {
          this.buyingJourney.nextStepButton.dataset.increment = 0;
          console.log("Keep steps 9, 10, and 11 because blinds = no");
          this.skipAstragalStep = false;
        }
      });
    });

    if (this.buyingJourneyObject.blinds.variantId != null || this.buyingJourneyObject.panelGlass.variantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.panelGlass.variantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }

      // Pre-select the blind radio based on saved state
      if (this.buyingJourneyObject.blinds.variantId != null) {
        const blindToSelect = this.target.querySelector(
          'input[name="blinds"][data-variant-id="' +
          this.buyingJourneyObject.blinds.variantId +
          '"]'
        );
        if (blindToSelect) {
          blindToSelect.checked = true;
        }
      }

      // If blind is already selected in the product object, check its value and set increment accordingly
      const selectedBlind = this.target.querySelector(
        'input[name="blinds"]:checked'
      );
      if (selectedBlind) {
        if (selectedBlind.value.toLowerCase() === "yes") {
          this.buyingJourney.nextStepButton.dataset.increment = 3;
          console.log(
            "Skip steps 9, 10, and 11 because blinds = yes (from previously selected)"
          );
          this.getBlind();
          this.skipAstragalStep = true;
        } else {
          this.buyingJourney.nextStepButton.dataset.increment = 0;
          console.log(
            "Keep steps 9, 10, and 11 because blinds = no (from previously selected)"
          );
          this.skipAstragalStep = false;
        }
      }
    }
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    this.setupOptionListeners('input[name="blinds"]');
    console.log(this.buyingJourneyObject);
  }

  // Step 9: Show the blind
  getBlind() {
    console.log("Panel Bar Type");

    const selectedGlass = this.target.querySelector(
      'input[name="glass_size"]:checked'
    );

    if (selectedGlass) {
      this.buyingJourneyObject.panelGlass.value = selectedGlass.value;
      this.buyingJourneyObject.panelGlass.variantId =
        selectedGlass.dataset.variantId;
      this.buyingJourneyObject.panelGlass.totalPrice = this.convertPrice(
        selectedGlass.dataset.price
      );
    }

    const selectedGlassVariantId = this.buyingJourneyObject.panelGlass.variantId;
    if (
      ["55029469544783", "55029469577551", "55029469708623"].includes(
        selectedGlassVariantId
      )
    ) {
      this.buyingJourney.prevStepButton.dataset.decrement = 0;
      const selectedBlind = this.target.querySelector(
        'input[name="blinds"]:checked'
      );

      if (selectedBlind) {
        const finalPriceBlindElement = selectedBlind
          .closest(".panel-wrapper")
          ?.querySelector(".panel-price[data-final-price]");
        this.buyingJourneyObject.blinds.value = selectedBlind.value;
        this.buyingJourneyObject.blinds.variantId =
          selectedBlind.dataset.variantId;
        this.buyingJourneyObject.blinds.totalPrice = finalPriceBlindElement
          ? this.convertPrice(finalPriceBlindElement.dataset.finalPrice)
          : 0;
      }
    } else {
      this.buyingJourneyObject.blinds.value = null;
      this.buyingJourneyObject.blinds.variantId = null;
      this.buyingJourneyObject.blinds.totalPrice = 0;
      this.buyingJourney.prevStepButton.dataset.decrement = 1;
    }
    if (this.buyingJourneyObject.barsfitting.typeVariantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.barsfitting.typeVariantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
        // Manually set increment — event listeners aren't attached yet
        // so the change handler won't call setIncrementForButtons
        this.setIncrementForButtons(selectedOption.value, 8);
      }
    }

    const fittingBarsOptions = this.target.querySelectorAll(
      'input[name="panel_bar_type"]'
    );
    fittingBarsOptions.forEach((radio) => {
      radio.addEventListener("change", () => {
        const selectedFitting = this.target.querySelector(
          'input[name="panel_bar_type"]:checked'
        );
        this.buyingJourneyObject.barsfitting.value = selectedFitting.value;
        this.buyingJourneyObject.barsfitting.typeVariantId =
          selectedFitting.dataset.variantId;
        this.setIncrementForButtons(selectedFitting.value, 8);
      });

      // check if customer choose blinds then disable the astragal bars
      if (
        this.buyingJourneyObject.blinds?.value?.toLowerCase() === "yes" &&
        radio.value.toLowerCase() === "yes"
      ) {
        radio.disabled = true;
        radio.checked = false;
      } else {
        radio.disabled = false;
      }
    });

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    this.setupOptionListeners('input[name="panel_bar_type"]');
  }

  //Step 9: Show the Bars Orientation and get the selected bars type.
  getBarsFittingType() {
    console.log("Bars Fitting Orientation");

    if (this.buyingJourneyObject.barsfitting.orientationVariantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.barsfitting.orientationVariantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_bar_orientation"]');
  }

  getBarsFittingOrientation() {
    console.log("Bars Fitting Quantity");

    if (this.buyingJourneyObject.barsfitting.quantityVariantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.barsfitting.quantityVariantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    const selectedFittingOrientation = this.target.querySelector(
      'input[name="panel_bar_orientation"]:checked'
    );
    const quantityFittingBars = this.target.querySelectorAll(
      'input[name="panel_bar_quantity"]'
    );

    if (selectedFittingOrientation) {
      quantityFittingBars.forEach((element) => {
        const isSameDirection = element.dataset.variantTitle
          .toLowerCase()
          .includes(selectedFittingOrientation.value.toLowerCase());
        element.parentElement.classList.toggle("hidden", !isSameDirection);
      });

      this.buyingJourneyObject.barsfitting.direction =
        selectedFittingOrientation.value;
      this.buyingJourneyObject.barsfitting.orientationVariantId =
        selectedFittingOrientation.dataset.variantId;
    }

    const selectedBarsFitting = this.target.querySelector(
      'input[name="panel_bar_type"]:checked'
    );

    if (selectedBarsFitting) {
      if (selectedBarsFitting.value == "transom") {
        selectedBarsFitting
          .closest(".step-container")
          .nextElementSibling.nextElementSibling.querySelector(
            ".step-heading"
          ).innerHTML = "Choose the number of Transom bars you'd like to add.";
        this.buyingJourney.prevStepButton.dataset.decrement = 1;
        this.buyingJourney.nextStepButton.dataset.increment = 0;
      } else {
        selectedBarsFitting
          .closest(".step-container")
          .nextElementSibling.nextElementSibling.querySelector(
            ".step-heading"
          ).innerHTML =
          "Choose the number of " +
          this.buyingJourneyObject.barsfitting.direction +
          " Astragal bars you'd like to add.";
      }
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_bar_quantity"]');
  }

  getBarsFittingQuantity() {
    console.log("Trickle Vents");

    if (this.buyingJourneyObject.trickleVents.variantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.trickleVents.variantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    const selectedFittingQuantity = this.target.querySelector(
      'input[name="panel_bar_quantity"]:checked'
    );
    const selectedBarsFitting = this.target.querySelector(
      'input[name="panel_bar_type"]:checked'
    );

    if (this.skipAstragalStep) {
      this.setDecrementForButtons("skipAstragal");
    } else {
      if (selectedBarsFitting) {
        this.setDecrementForButtons(selectedBarsFitting.value);
      }
    }

    if (selectedFittingQuantity) {
      this.buyingJourneyObject.barsfitting.quantityVariantId =
        selectedFittingQuantity.dataset.variantId;
      this.buyingJourneyObject.barsfitting.quantity = selectedFittingQuantity.value;
      this.buyingJourneyObject.barsfitting.totalPrice = this.convertPrice(selectedFittingQuantity.dataset.price);

    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="trickle-vent"]');
  }

  getTrickleVents() {
    console.log("Profile Addons");

    const selectedBarsFitting = this.target.querySelector(
      'input[name="panel_bar_type"]:checked'
    );

    if (selectedBarsFitting) {
      this.setDecrementForButtons(selectedBarsFitting.value);
      if (selectedBarsFitting.value == "no") {
        this.buyingJourneyObject.barsfitting.quantity = 0;
        this.buyingJourneyObject.barsfitting.totalPrice = 0;
        this.buyingJourneyObject.barsfitting.direction = null;
      }
    }

    const selectedTrickleOption = this.target.querySelector(
      'input[name="trickle-vent"]:checked'
    );

    if (selectedTrickleOption) {
      this.buyingJourneyObject.trickleVents.value = selectedTrickleOption.value;
      this.buyingJourneyObject.trickleVents.variantId =
        selectedTrickleOption.dataset.variantId;
      this.buyingJourneyObject.trickleVents.totalPrice = this.convertPrice(
        selectedTrickleOption.dataset.price
      );
    }

    const isAddonsNotRequired = this.target.querySelector(
      'input[name="addons_notRequired"]'
    );

    if (isAddonsNotRequired) {
      isAddonsNotRequired.addEventListener("change", () => {
        this.getAddonProfile(isAddonsNotRequired.checked);
      });
      isAddonsNotRequired.dispatchEvent(this.buyingJourney.changeEvent);
    }

    console.log(this.buyingJourneyObject);
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
  }

  getAddonProfile(isAddonsNotRequired) {
    const left_side = this.target.querySelector('select[name="left_side"]');
    const right_side = this.target.querySelector('select[name="right_side"]');
    const top_side = this.target.querySelector('select[name="top_side"]');

    const classInstance = this;
    setDisableforAddonprofiles();

    if (isAddonsNotRequired == false) {
      console.log("Addons Required");

      if (left_side) {
        let selectedLeftFrameLength =
          left_side.options[left_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.left = "0mm";
        left_side.addEventListener("change", () => {
          selectedLeftFrameLength = left_side.options[left_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.left =
            selectedLeftFrameLength.value;
          this.buyingJourneyObject.profileAddons.leftPrice = this.convertPrice(
            selectedLeftFrameLength.dataset.price *
            (this.buyingJourneyObject.panelInfo.panelHeight / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (right_side) {
        let selectedRightFrameLength =
          right_side.options[right_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.right = "0mm";
        right_side.addEventListener("change", () => {
          selectedRightFrameLength =
            right_side.options[right_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.right =
            selectedRightFrameLength.value;
          this.buyingJourneyObject.profileAddons.rightPrice = this.convertPrice(
            selectedRightFrameLength.dataset.price *
            (this.buyingJourneyObject.panelInfo.panelHeight / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (top_side) {
        let selectedTopFrameLength = top_side.options[top_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.top = "0mm";
        top_side.addEventListener("change", () => {
          selectedTopFrameLength = top_side.options[top_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.top =
            selectedTopFrameLength.value;
          this.buyingJourneyObject.profileAddons.topPrice = this.convertPrice(
            selectedTopFrameLength.dataset.price *
            (this.buyingJourneyObject.panelInfo.panelWidth / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (this.buyingJourneyObject.profileAddons.left != null) {
        const selectedOption = this.target.querySelector(
          'select[name="left_side"]'
        );
        selectedOption.value = this.buyingJourneyObject.profileAddons.left;
      }

      if (this.buyingJourneyObject.profileAddons.right != null) {
        const selectedOption = this.target.querySelector(
          'select[name="right_side"]'
        );
        selectedOption.value = this.buyingJourneyObject.profileAddons.right;
      }

      if (this.buyingJourneyObject.profileAddons.top != null) {
        const selectedOption = this.target.querySelector(
          'select[name="top_side"]'
        );
        selectedOption.value = this.buyingJourneyObject.profileAddons.top;
      }

      this.buyingJourneyObject.profileAddons.value = "Required";
    } else {
      this.buyingJourneyObject.profileAddons = {};
      this.buyingJourneyObject.profileAddons.value = "Not Required";
      this.buyingJourneyObject.profileAddons.left = "0mm";
      this.buyingJourneyObject.profileAddons.leftPrice = 0;
      this.buyingJourneyObject.profileAddons.top = "0mm";
      this.buyingJourneyObject.profileAddons.topPrice = 0;
      this.buyingJourneyObject.profileAddons.right = "0mm";
      this.buyingJourneyObject.profileAddons.rightPrice = 0;
    }

    function setDisableforAddonprofiles() {
      if (
        isAddonsNotRequired == false &&
        (left_side.value == "no" ||
          right_side.value == "no" ||
          top_side.value == "no")
      ) {
        classInstance.buyingJourney.setDisableNextButton();
      } else {
        classInstance.buyingJourney.setActiveNextButton();
      }
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
  }

  handleThreshold() {
    console.log("Get Addons");

    if (this.buyingJourneyObject.threshold.variantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.threshold.variantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    const integratedThresholdAndCill = this.target.querySelector(
      'input[name="threshold"][id="threshold-integrated-threshold-/-cill"]'
    );
    if (integratedThresholdAndCill) {
      if (
        this.buyingJourneyObject.panelInfo.orientation == "inwards" &&
        integratedThresholdAndCill
      ) {
        integratedThresholdAndCill.parentElement.classList.add("hidden");
      } else {
        integratedThresholdAndCill.parentElement.classList.remove("hidden");
      }
    }

    const thresholdOptions = document.querySelectorAll(
      'input[name="threshold"]'
    );

    thresholdOptions.forEach((option) => {
      option.addEventListener("click", () => {
        if (option.value.toLowerCase().includes("integrated")) {
          this.buyingJourney.nextStepButton.dataset.increment = 1;
        } else {
          this.buyingJourney.nextStepButton.dataset.increment = 0;
        }
      });
    });

    const selectedThreshold = document.querySelector(
      'input[name="threshold"]:checked'
    );

    if (selectedThreshold) {
      if (selectedThreshold.value.toLowerCase().includes("integrated")) {
        this.buyingJourney.nextStepButton.dataset.increment = 1;
      } else {
        this.buyingJourney.nextStepButton.dataset.increment = 0;
      }
    }

    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    this.setupOptionListeners('input[name="threshold"]');

    console.log(this.buyingJourneyObject);
  }

  getThreshold() {
    console.log("Cill");

    const selectedThreshold = document.querySelector(
      'input[name="threshold"]:checked'
    );

    if (selectedThreshold) {
      this.buyingJourneyObject.threshold.value = selectedThreshold.value;
      this.buyingJourneyObject.threshold.variantId =
        selectedThreshold.dataset.variantId;
      this.buyingJourneyObject.threshold.totalPrice = this.convertPrice(
        selectedThreshold.dataset.price
      );
    }

    if (this.buyingJourneyObject.cill.variantId != null) {
      const selectedOption = this.target.querySelector(
        'input[data-variant-id="' +
        this.buyingJourneyObject.cill.variantId +
        '"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    this.setupOptionListeners('input[name="cill"]');
    console.log(this.buyingJourneyObject);
    if (Object.keys(this.buyingJourney.personDetails).length > 0) {
      this.buyingJourneyObject.gtAccessQoute.firstName =
        this.buyingJourney.personDetails.firstName;
      this.buyingJourneyObject.gtAccessQoute.lastName =
        this.buyingJourney.personDetails.lastName;
      this.buyingJourneyObject.gtAccessQoute.email =
        this.buyingJourney.personDetails.email;
      this.buyingJourneyObject.gtAccessQoute.mobile =
        this.buyingJourney.personDetails.phone;
      this.buyingJourneyObject.postCode.value =
        this.buyingJourney.personDetails.postcode;
    }
  }

  getCill() {
    console.log("PostCode");

    const selectedThreshold = this.target.querySelector(
      'input[name="threshold"]:checked'
    );
    if (selectedThreshold) {
      this.buyingJourneyObject.threshold.value = selectedThreshold.value;
      this.buyingJourneyObject.threshold.variantId =
        selectedThreshold.dataset.variantId;
      this.buyingJourneyObject.threshold.totalPrice = this.convertPrice(
        selectedThreshold.dataset.price
      );
    }

    if (this.buyingJourneyObject.threshold.value.includes("Integrated")) {
      this.buyingJourney.prevStepButton.dataset.decrement = 1;
      this.buyingJourneyObject.cill.value = null;
      this.buyingJourneyObject.cill.variantId = null;
      this.buyingJourneyObject.cill.totalPrice = 0;
    } else {
      this.buyingJourney.prevStepButton.dataset.decrement = 0;
      const selectedCill = this.target.querySelector(
        'input[name="cill"]:checked'
      );
      if (selectedCill) {
        this.buyingJourneyObject.cill.value = selectedCill.value;
        this.buyingJourneyObject.cill.variantId =
          selectedCill.dataset.variantId;
        this.buyingJourneyObject.cill.totalPrice = this.convertPrice(
          selectedCill.dataset.price *
          parseFloat(this.buyingJourneyObject.panelInfo.panelWidth / 1000)
        );
      }
    }

    if (this.buyingJourneyObject.postCode.value != null) {
      const selectedOption = this.target.querySelector(
        'input[name="post-code"]'
      );
      if (selectedOption) {
        selectedOption.value = this.buyingJourneyObject.postCode.value;
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }

    const postCodeOptions = this.target.querySelector(
      'input[name="post-code"]'
    );
    const postCodeInputs = [postCodeOptions];
    this.disableNextButtonOnEmptyInput(postCodeInputs);

    if (postCodeOptions) {
      postCodeOptions.addEventListener("change", () => {
        this.buyingJourneyObject.postCode.value = postCodeOptions.value;
        this.disableNextButtonOnEmptyInput(postCodeInputs);
      });
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
  }

  getpostcode() {
    console.log("Access Issues");
    const accessIssuesOptions = this.target.querySelectorAll(
      'input[name="delivery_access_issues"]'
    );
    this.buyingJourney.setDisableNextButton();
    if (accessIssuesOptions) {
      accessIssuesOptions.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.buyingJourney.setDisableNextButton();
          const selectedAccessIssue = this.target.querySelector(
            'input[name="delivery_access_issues"]:checked'
          );
          this.buyingJourneyObject.accessIssue.value =
            selectedAccessIssue.value;
          const accessIssueNote = this.target.querySelector(
            'textarea[name="access_issues_order_note"]'
          );
          if (this.buyingJourneyObject.accessIssue.value == "Yes") {
            accessIssueNote.addEventListener("change", () => {
              this.buyingJourney.setDisableNextButton();
              this.buyingJourneyObject.accessIssue.orderNote =
                accessIssueNote.value;
              if (
                this.buyingJourneyObject.accessIssue.value == "Yes" &&
                this.buyingJourneyObject.accessIssue.orderNote != null &&
                this.buyingJourneyObject.accessIssue.orderNote.trim() !== ""
              ) {
                this.buyingJourney.setActiveNextButton();
              }
            });
          } else if (this.buyingJourneyObject.accessIssue.value == "No") {
            accessIssueNote.value = null;
            this.buyingJourneyObject.accessIssue.orderNote = null;
            if (
              this.buyingJourneyObject.accessIssue.value == "No" &&
              this.buyingJourneyObject.accessIssue.orderNote == null
            ) {
              this.buyingJourney.setActiveNextButton();
            }
          }
        });
      });
      if (this.buyingJourneyObject.accessIssue.value != null) {
        const selectedOption = this.target.querySelector(
          'input[name="delivery_access_issues"][value="' +
          this.buyingJourneyObject.accessIssue.value +
          '"]'
        );
        if (selectedOption) {
          selectedOption.checked = true;
          if (this.buyingJourneyObject.accessIssue.value == "Yes") {
            this.target.querySelector(
              'input[name="access_issues_order_note"]'
            ).value = this.buyingJourneyObject.accessIssue.orderNote;
          }
          selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
        }
      }
    }
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    console.log(this.buyingJourneyObject);
  }

  //Gate access
  getGatewayAccessQuote() {
    console.log("Gateway Access");
    if (this.buyingJourneyObject.gtAccessQoute.firstName != null) {
      const selectedOption = this.target.querySelector(
        'input[name="contact[firstName]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.firstName;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.gtAccessQoute.lastName != null) {
      const selectedOption = this.target.querySelector(
        'input[name="contact[lastName]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.lastName;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.gtAccessQoute.email != null) {
      const selectedOption = this.target.querySelector(
        'input[name="contact[email]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.email;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    if (this.buyingJourneyObject.gtAccessQoute.mobile != null) {
      const selectedOption = this.target.querySelector(
        'input[name="contact[phone]"]'
      );
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.mobile;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const accessQuoteInputs = this.target.querySelectorAll(".step-gtaq input");
    this.disableNextButtonOnEmptyInput(accessQuoteInputs);

    accessQuoteInputs.forEach((input) => {
      input.addEventListener("change", () => {
        switch (input.name) {
          case "contact[firstName]":
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.firstName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.firstName = null;
            }
            break;
          case "contact[lastName]":
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.lastName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.lastName = null;
            }
            break;
          case "contact[phone]":
            {
              const IsValidFormat = this.buyingJourney.validateAndFormatPhone(
                input.value,
                "GB"
              );
              console.log("Is phone number is valid? " + IsValidFormat.valid);
              if (input.value.length == 11 && IsValidFormat.valid) {
                this.buyingJourneyObject.gtAccessQoute.mobile = input.value;
                input.classList.remove("invalid");
              } else {
                this.buyingJourneyObject.gtAccessQoute.mobile = null;
                input.classList.add("invalid");
              }
            }
            break;
          case "contact[email]":
            if (this.buyingJourney.validateEmail()) {
              console.log("valid Email");
              this.buyingJourneyObject.gtAccessQoute.email = input.value;
            } else {
              console.log("Invalid Email");
              this.buyingJourneyObject.gtAccessQoute.email = null;
            }
            break;
          default:
            console.log("no input");
            break;
        }

        if (
          this.buyingJourneyObject.gtAccessQoute.firstName &&
          this.buyingJourneyObject.gtAccessQoute.lastName &&
          this.buyingJourneyObject.gtAccessQoute.mobile &&
          this.buyingJourneyObject.gtAccessQoute.email
        ) {
          this.buyingJourney.setActiveNextButton();
        } else {
          this.buyingJourney.setDisableNextButton();
        }
      });
    });
  }

  handleAddMoreProducts() {
    this.buyingJourney.setDisableNextButton();
    const classInstance = this;
    this.buyingJourney.querySelectorAll(".add-product-label").forEach((input) =>
      input.addEventListener("click", async function () {
        if (this.dataset.url && this.dataset.url != "#") {
          document.querySelector(
            ".adding-to-cart-loading-wraper"
          ).style.display = "block";
          await classInstance.buyingJourney.createBuyingJourneyProduct();
          console.log("Product Added to cart, Ready to switch to new page");
          document.querySelector(
            ".adding-to-cart-loading-wraper"
          ).style.display = "none";
          window.location.href = this.dataset.url;
        }
        if (this.value == "nothanks") {
          classInstance.buyingJourney.createQuoteFlag = true; //set the quote flag to true to generate the quote
          classInstance.buyingJourney.nextStepButton.disabled = false;
          classInstance.buyingJourney.nextStepButton.classList.remove(
            "disabled"
          );
        }
      })
    );

    const noThanksLabel = this.buyingJourney.querySelector("#no-thanks");

    if (!noThanksLabel || noThanksLabel.checked) {
      this.buyingJourney.setActiveNextButton();
    }
  }

  getProductFinalPrice() {
    console.log(
      "Total price:",
      Math.round(
        this.convertPrice(
          this.buyingJourneyObject.panelSize.totalPrice *
          this.buyingJourneyObject.panelSize.value +
          this.buyingJourneyObject.panelOutsideColour.totalPrice *
          this.buyingJourneyObject.panelOutsideColour.quantity +
          this.buyingJourneyObject.panelInsideColour.totalPrice *
          this.buyingJourneyObject.panelInsideColour.quantity +
          this.buyingJourneyObject.panelHandle.totalPrice *
          this.buyingJourneyObject.panelHandle.quantity +
          this.buyingJourneyObject.panelGlass.totalPrice *
          this.buyingJourneyObject.panelGlass.quantity +
          this.buyingJourneyObject.barsfitting.totalPrice *
          this.buyingJourneyObject.barsfitting.quantity +
          this.buyingJourneyObject.trickleVents.totalPrice *
          this.buyingJourneyObject.trickleVents.quantity +
          (this.buyingJourneyObject.profileAddons.leftPrice +
            this.buyingJourneyObject.profileAddons.rightPrice +
            this.buyingJourneyObject.profileAddons.topPrice) +
          this.buyingJourneyObject.cill.totalPrice +
          this.buyingJourneyObject.threshold.totalPrice +
          this.buyingJourneyObject.blinds.totalPrice
        )
      )
    );
    this.buyingJourneyObject.totalPrice = Math.round(
      this.convertPrice(
        this.buyingJourneyObject.panelSize.totalPrice *
        this.buyingJourneyObject.panelSize.quantity +
        this.buyingJourneyObject.panelOutsideColour.totalPrice *
        this.buyingJourneyObject.panelOutsideColour.quantity +
        this.buyingJourneyObject.panelInsideColour.totalPrice *
        this.buyingJourneyObject.panelInsideColour.quantity +
        this.buyingJourneyObject.panelHandle.totalPrice *
        this.buyingJourneyObject.panelHandle.quantity +
        this.buyingJourneyObject.panelGlass.totalPrice *
        this.buyingJourneyObject.panelGlass.quantity +
        this.buyingJourneyObject.barsfitting.totalPrice +
        this.buyingJourneyObject.trickleVents.totalPrice *
        this.buyingJourneyObject.trickleVents.quantity +
        (this.buyingJourneyObject.profileAddons.leftPrice +
          this.buyingJourneyObject.profileAddons.rightPrice +
          this.buyingJourneyObject.profileAddons.topPrice) +
        this.buyingJourneyObject.cill.totalPrice +
        this.buyingJourneyObject.threshold.totalPrice +
        this.buyingJourneyObject.blinds.totalPrice
      )
    );

    return this.buyingJourneyObject.totalPrice;
  }

  collectProductData() {
    const productData = {
      title: "Aluminium Bifold Door",
      handle: "your-order-" + this.buyingJourney.generateRandomSixDigitNumber(),
      body_html: `
          <p style="text-align: left;"><strong>Access Issues: </strong> ${this.buyingJourneyObject.accessIssue.value == "No"
          ? this.buyingJourneyObject.accessIssue.value
          : this.buyingJourneyObject.accessIssue.orderNote
        }</p>
          <p style="text-align: left;"><strong>Manufacturing Size: </strong> ${this.buyingJourneyObject.panelInfo.panelWidth +
        "x" +
        this.buyingJourneyObject.panelInfo.panelHeight
        }</p>
          <p style="text-align: left;"><strong>Panels: </strong> ${this.buyingJourneyObject.panelSize.value
        }</p>
          <p style="text-align: left;"><strong>Stacking Direction: </strong>${this.buyingJourneyObject.panelSize.stackingDirection
        }</p>
          <p style="text-align: left;"><strong>Opening Direction: </strong>  ${this.buyingJourneyObject.panelInfo.orientation
        }</p>
          <p style="text-align: left;"><strong>Outside Colour: </strong> ${this.buyingJourneyObject.panelOutsideColour.value
        }</p>
          <p style="text-align: left;"><strong>Inside Colour: </strong> ${this.buyingJourneyObject.panelInsideColour.value
        }</p>
          <p style="text-align: left;"><strong>Cill: </strong>${this.buyingJourneyObject.cill.value
        }</p>
          <p style="text-align: left;"><strong>Threshold: </strong>${this.buyingJourneyObject.threshold.value
        }</p>
          <p style="text-align: left;"><strong>Glass: </strong>${this.buyingJourneyObject.panelGlass.value
        }</p>
          <p style="text-align: left;"><strong>Blinds: </strong>${this.buyingJourneyObject.blinds.value
        }</p>
          <p style="text-align: left;"><strong>Handle Colour: </strong>${this.buyingJourneyObject.panelHandle.value
        }</p>
          <p style="text-align: left;"><strong>Trickle Vents: </strong>${this.buyingJourneyObject.trickleVents.value
        }</p>
          <p style="text-align: left;"><strong>Top Addon: </strong>${this.buyingJourneyObject.profileAddons.top
        }</p>
          <p style="text-align: left;"><strong>Right Addon: </strong>${this.buyingJourneyObject.profileAddons.right
        }</p>
          <p style="text-align: left;"><strong>Left Addon: </strong>${this.buyingJourneyObject.profileAddons.left
        }</p>
          <p style="text-align: left;"><strong>Hinge Colour: </strong>Black</p>
          <p style="text-align: left;"><strong>Astragal Bars: </strong>${this.buyingJourneyObject.barsfitting.direction !== "null"
          ? this.buyingJourneyObject.barsfitting.direction
          : "No"
        }</p>

          <p style="text-align: left;"><strong>Total price:</strong> £${this.buyingJourneyObject.totalPrice
        } </p>
          `,
      vendor: "NOW Aluminium",
      product_type: "quote-product",
      variants: [
        {
          price: this.getProductFinalPrice(),
        },
      ],
      images: [
        {
          src: this.buyingJourneyObject.panelSize.panelImage, // Assuming this is the URL to the product image
        },
      ],
      properties: this.getProductProperties(),
    };
    return productData;
  }

  //Helper Functions

  validateInput(productObject, input) {
    if (input) {
      switch (input.name) {
        case "panel-width":
          productObject.panelInfo.panelWidth = parseInt(input.value, 10) || 0;
          break;
        case "panel-height":
          productObject.panelInfo.panelHeight = parseInt(input.value, 10) || 0;
        default:
          break;
      }
      var isValid = true;
      const value = parseInt(input.value, 10);

      if (!isNaN(value)) {
        isValid = true;
        if (input.hasAttribute("min") && input.hasAttribute("max")) {
          isValid = value >= input.min && value <= input.max;
        }
      }

      input.classList.toggle("invalid", !isValid);
      if (input.parentElement.nextElementSibling) {
        input.parentElement.nextElementSibling.classList.toggle(
          "show",
          !isValid
        );
      }
      if (this.validateStep()) {
        return true;
      } else {
        return false;
      }
    }
  }

  setIncrementForButtons(selectedFitting, triggerStepNumber = null) {
    const selectedFittingdowncased = selectedFitting.toLowerCase();
    switch (selectedFittingdowncased) {
      case "yes":
        this.buyingJourney.unskipNextNSteps(2, triggerStepNumber);
        this.buyingJourney.nextStepButton.dataset.increment = 0;
        break;
      case "no":
        this.buyingJourney.skipNextNSteps(2, triggerStepNumber);
        this.buyingJourney.nextStepButton.dataset.increment = 2;
        break;
      default:
        // do nothing
        break;
    }
  }

  setDecrementForButtons(selectedFitting) {
    const { buyingJourney } = this;
    switch (selectedFitting) {
      case "yes":
        this.buyingJourney.prevStepButton.dataset.decrement = 0;
        break;
      case "no":
        this.buyingJourney.prevStepButton.dataset.decrement = 2;
        break;
      case "skipAstragal":
        this.buyingJourney.prevStepButton.dataset.decrement = 3;
        break;
      default:
        // do nothing
        break;
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
  }

  validateStep() {
    const activeInputs = this.target.querySelectorAll(".step-size input");
    return Array.from(activeInputs).every(
      (input) => input && input.value && !input.classList.contains("invalid")
    );
  }

  setupOptionListeners(selector) {
    const options = this.target.querySelectorAll(selector);

    options.forEach((option) =>
      option.addEventListener("change", () => {
        if (option) option.checked = true;
        this.disableNextButtonOnNonSelection(options);
      })
    );
    this.disableNextButtonOnNonSelection(options);
  }

  disableNextButtonOnNonSelection(options) {
    const anyChecked = Array.from(options).some(
      (option) => option && option.checked
    );
    if (anyChecked) {
      this.buyingJourney.setActiveNextButton();
    } else {
      this.buyingJourney.setDisableNextButton();
    }
  }

  convertPrice(price) {
    let priceRounded;
    if (price) {
      let decimalPrice = parseFloat(price); // Convert the price to a float
      priceRounded = Math.round(decimalPrice * 100.0) / 100; // Multiply by 100, round, then divide by 100
    } else {
      priceRounded = 0;
    }
    return priceRounded;
  }

  disableNextButtonOnEmptyInput(inputs) {
    const allFilled = Array.from(inputs).every(
      (input) => input && input.value.trim() !== ""
    );
    if (allFilled) {
      this.buyingJourney.setActiveNextButton();
    } else {
      this.buyingJourney.setDisableNextButton();
    }
  }

  getProductProperties() {
    return {
      "First name": `${this.buyingJourneyObject.gtAccessQoute.firstName}`,
      "Last name": `${this.buyingJourneyObject.gtAccessQoute.lastName}`,
      Email: `${this.buyingJourneyObject.gtAccessQoute.email}`,
      Phone: `${this.buyingJourneyObject.gtAccessQoute.mobile}`,
      Postcode: `${this.buyingJourneyObject.postCode}`,
      "Panel width": `${this.buyingJourneyObject.panelInfo.panelWidth}`,
      "Panel height": `${this.buyingJourneyObject.panelInfo.panelHeight}`,
      Orientation: `${this.buyingJourneyObject.panelInfo.orientation}`,
      "No. of panels": `${this.buyingJourneyObject.panelSize.value}`,
      "Product type": `${this.buyingJourneyObject.productType}`,
      "Stacking direction": `${this.buyingJourneyObject.panelSize.stackingDirection}`,
      "Panel outside color": `${this.buyingJourneyObject.panelOutsideColour.value}`,
      "Panel inside color": `${this.buyingJourneyObject.panelInsideColour.value}`,
      "Panel handle": `${this.buyingJourneyObject.panelHandle.value}`,
      "Panel glass": `${this.buyingJourneyObject.panelGlass.value}`,
      Blinds: `${this.buyingJourneyObject.blinds.value}`,
      "Astragal bars": `${this.buyingJourneyObject.barsfitting.value}`,
      "Astragal bars direction": `${this.buyingJourneyObject.barsfitting.direction}`,
      "Number of astragal bars": `${this.buyingJourneyObject.barsfitting.quantity}`,
      "Trickle vents": `${this.buyingJourneyObject.trickleVents.value}`,
      "Profile addons": `${this.buyingJourneyObject.profileAddons.value}`,
      "Profile addons left": `${this.buyingJourneyObject.profileAddons.left}`,
      "Profile addons top": `${this.buyingJourneyObject.profileAddons.top}`,
      "Profile addons right": `${this.buyingJourneyObject.profileAddons.right}`,
      Postcode: `${this.buyingJourneyObject.postCode.value}`,
      Cill: `${this.buyingJourneyObject.cill.value}`,
      Threshold: `${this.buyingJourneyObject.threshold.value}`,
      "Access issues": `${this.buyingJourneyObject.accessIssue.value}`,
      "Access issues note": `${this.buyingJourneyObject.accessIssue.orderNote}`,
      "Panel image": `${this.buyingJourneyObject.panelSize.panelImage}`,
      "Verified Email": `${this.buyingJourney.emailVerified}`,
      _buyingJourneyObject: this.buyingJourney.TokenUtils.encode(this.buyingJourneyObject),
    };
  }

  convertOrderItemsIntoProductObject(orderItem) {
    const props = orderItem.properties || {};
    let _buyingJourneyObject = null;
    if (props["_buyingJourneyObject"]) {
      if (!props["_buyingJourneyObject"].includes("{")) {
        _buyingJourneyObject = this.buyingJourney.TokenUtils.decode(props["_buyingJourneyObject"]);
      } else {
        _buyingJourneyObject = JSON.parse(props["_buyingJourneyObject"]);
      }
    }
    return {
      id: orderItem.id,
      product_id: orderItem.product_id,
      title: orderItem.product_title,
      totalPrice: orderItem.price,

      panelSize: {
        panelImage: orderItem.image || orderItem.properties["Panel image"],
        value: props["No. of panels"],
        stackingDirection: props["Stacking direction"],
      },

      panelInfo: {
        panelWidth: props["Panel width"],
        panelHeight: props["Panel height"],
        orientation: props["Orientation"],
      },

      panelOutsideColour: { value: props["Panel outside color"] },
      panelInsideColour: { value: props["Panel inside color"] },
      panelHandle: { value: props["Panel handle"] },
      panelGlass: { value: props["Panel glass"] },
      blinds: { value: props["Blinds"] },

      barsfitting: {
        value: props["Number of astragal bars"],
        direction: props["Astragal bars direction"],
      },

      trickleVents: { value: props["Trickle vents"] },

      profileAddons: {
        left: props["Profile addons left"],
        right: props["Profile addons right"],
        top: props["Profile addons top"],
        value: props["Profile addons"],
      },

      postCode: { value: props["Postcode"] },
      cill: { value: props["Cill"] },
      threshold: { value: props["Threshold"] },

      accessIssue: {
        value: props["Access issues"],
        orderNote: props["Access issues note"],
      },

      gtAccessQoute: {
        firstName: props["First name"],
        lastName: props["Last name"],
        mobile: props["Phone"],
        email: props["Email"],
      },
      productType: props["Product type"],
      _buyingJourneyObject: {
        ..._buyingJourneyObject,
        id: orderItem.id,
        product_id: orderItem.product_id,
        title: this.buyingJourneyObject.title,
      },
    };
  }

  createQuoteItemElement(item) {
    const { buyingJourney } = this;

    // Safely extract all needed values with defaults
    const title = item?.title ?? "";
    const totalPrice = item?.totalPrice ?? 0;
    const panelImage = item?.panelSize?.panelImage ?? "";
    const panelWidth = item?.panelInfo?.panelWidth ?? "";
    const panelHeight = item?.panelInfo?.panelHeight ?? "";
    const stackingDirection = item?.panelSize?.stackingDirection ?? "";
    const outsideColour = item?.panelOutsideColour?.value ?? "";
    const accessOrderNote = item?.accessIssue?.orderNote;
    const accessIssueText =
      !accessOrderNote || accessOrderNote === "null" ? "No" : accessOrderNote;
    const orientation = item?.panelInfo?.orientation ?? "";
    const topAddon = item?.profileAddons?.top ?? "";
    const leftAddon = item?.profileAddons?.left ?? "";
    const rightAddon = item?.profileAddons?.right ?? "";
    const handleColour = item?.panelHandle?.value ?? "";
    const trickleVents = item?.trickleVents?.value ?? "";
    const hingeColour = "Black"; // constant in original
    const barsDirection = item?.barsfitting?.direction !== 'null' ? item?.barsfitting?.direction : 'No';

    const panelsValue = item?.panelSize?.value ?? "";
    const insideColour = item?.panelInsideColour?.value ?? "";
    const glass = item?.panelGlass?.value ?? "";
    const cillValue = item?.cill?.value;
    const cill = !cillValue || cillValue === "null" ? "No" : cillValue;
    const blindsValue = item?.blinds?.value;
    const blinds = !blindsValue || blindsValue === "null" ? "No" : blindsValue;
    const threshold = item?.threshold?.value ?? "";
    const delivery = "Standard"; // constant in original

    const div = document.createElement("div");
    div.className = "bj-cart-bottom";
    div.innerHTML = `
      <div class="bj-cart-bottom-right-top accordion-toggle">
        <div class="cart-accor-header-left">
          <h2 class="bj-cart-heading accordion-toggle">${title}</h2>
          <div class="bj-cart-total-price">
            <span class="bj-cart-price" data-price="${totalPrice}" data-order-price>${Shopify.formatMoney(
      totalPrice
    )}</span>
            <span class="bj-cart-price-text">+ VAT</span>
          </div>
        </div>
        <div class="cart-accor-header-right">
        <a class="bj-cart-image-text removeQuoteProduct" data-item-id="${item.id
      }" data-product-id="${item.product_id}">
          <span>Remove</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="21.8047" y="0.199219" width="21.601" height="21.601" rx="10.8005" transform="rotate(90 21.8047 0.199219)" fill="#967b50"/>
            <path d="M8.45014 7.98345L14.0186 7.98345L14.0186 13.5519M13.6319 8.37015L7.9861 14.016" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>        
          <button type="button" class="accordion-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
              <rect y="0.224609" width="28" height="28" rx="14" fill="#967b50"></rect>
              <path d="M7.51465 15.8193L13.9999 9.33398L20.4852 15.8193" stroke="#f1f1f1" stroke-width="1.64706" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      </div>
      <div class="bj-cart-bottom-in">
        <div class="bj-cart-bottom-in-left">
          <div class="cart-item-image">
            <img id="order-featured-image" src="${panelImage}" alt="${title}" class="bj-cart-image" />
          </div>
        </div>
        <div class="bj-cart-bottom-in-right">
          <div class="bj-cart-bottom-right-center">
            <h3 class="bj-cart-detail-heading">Your door</h3>
            <div class="bj-cart-details">
              ${buyingJourney.renderDetail(
        "Manufacturing size (mm)",
        `${panelWidth} x ${panelHeight}`,
        "1",
        "1"
      )}
              ${buyingJourney.renderDetail(
        "Stacking direction",
        stackingDirection,
        "2",
        "0"
      )}
              ${buyingJourney.renderDetail(
        "Outside colour",
        outsideColour,
        "4",
        "0"
      )}
              ${buyingJourney.renderDetail(
        "Access issues",
        accessIssueText,
        "17",
        "0"
      )}
              ${buyingJourney.renderDetail(
        "Opening directions",
        orientation,
        "3",
        "0"
      )}
              ${buyingJourney.renderDetail("Top addon", topAddon, "13", "0")}
              ${buyingJourney.renderDetail(
        "Handle colour",
        handleColour,
        "6",
        "0"
      )}
              ${buyingJourney.renderDetail("Left addon", leftAddon, "13", "0")}
              ${buyingJourney.renderDetail(
        "Trickle vents",
        trickleVents,
        "12",
        "0"
      )}
              ${buyingJourney.renderDetail(
        "Hinge colour",
        hingeColour,
        "",
        "0"
      )}
              ${buyingJourney.renderDetail(
        "Astragal bars",
        barsDirection,
        "9",
        "2"
      )}
              ${buyingJourney.renderDetail(
        "Right addon",
        rightAddon,
        "13",
        "0"
      )}
              ${buyingJourney.renderDetail("Panels", panelsValue, "2", "0")}
              ${buyingJourney.renderDetail(
        "Inside colour",
        insideColour,
        "5",
        "0"
      )}
              ${buyingJourney.renderDetail("Glass", glass, "7", "0")}
              ${buyingJourney.renderDetail("Cill", cill, "15", "0")}
              ${buyingJourney.renderDetail("Blinds", blinds, "8", "0")}
              ${buyingJourney.renderDetail("Threshold", threshold, "14", "0")}
              ${buyingJourney.renderDetail("Delivery", delivery, "", "0")}
            </div>
          </div>
        </div>
      </div>
    `;

    // Attach remove handler

    // Attach edit handlers (if any)
    div.querySelectorAll(".edit-option")?.forEach((option) =>
      option.addEventListener("click", () => {
        this.editHandler(option, item);
      })
    );
    return div;
  }

  editHandler(input, object) {
    const draftOrderId = this.buyingJourney.draftOrderId;
    const stepIndex = input.dataset.dialogId;
    // write an object to the localestoarge
    const editObject = {
      object,
      draftOrderId,
    };
    localStorage.setItem("modified-product", JSON.stringify(editObject));
    window.location.href = `/pages/bifold-door-builder?step=${stepIndex}&edit-order=true`;
  }
}
window.AluminiumBifoldDoor = AluminiumBifoldDoor;
